import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RotationMeter from './RotationKpiMeter';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appHelper from '../../../helpers/appHelper';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as kpiModels from '../../../models/kpiModels';

class ScoreKpi extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            lang: this.props.lang,
            userKpisResults: kpiHelper.setKpiRenderOrder(this.props.userKpisResults),
            bite: this.props.bite,
            score_kpi: kpiHelper.getScoreKpi(this.props.bite),
            locale: {},
            guid: dataHelper.createGuid(),
            allowUpdates: true,
            updatedKpis: [],
            checkAllUpdated: false
        };

        this.getKpiMeterParams = this.getKpiMeterParams.bind(this);
        this.getLocale = this.getLocale.bind(this);
        this.showDashboard = this.showDashboard.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.onUpdateComplete = this.onUpdateComplete.bind(this);

        this.objectRef = React.createRef();
    }

    componentDidMount() {
        if(appHelper.isDefined(this.state.score_kpi.kpi_id)){
            this.getLocale();
            this.showDashboard();
        }else{
            this.onUpdateComplete();
        }

    }

    componentWillReceiveProps(nextProps) {

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.bite)
            });
        }

    }

    shouldComponentUpdate() {
        return this.state.allowUpdates;
    }

    componentDidUpdate() {

    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.bite);
        this.setState({locale: Object.assign({}, locale)});
    }


    getKpiMeterParams(is_primary) {
        if (is_primary) {
            return kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS;
        } else {
            if (this.state.kpis.length < 3) {
                return kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS;
            } else {
                return kpiModels.DEFAULT_KPI_ROTATION_METER_PARAMS;
            }
        }
    }

    showDashboard() {
        this.onComplete();
    }

    onComplete() {
        if (!this.props.responseReview) {
            this.setState({allowUpdates: false});
        }

        if (typeof this.props.onComplete !== 'undefined') {
            this.props.onComplete();
        }
    }

    onUpdateComplete(kpi_id) {
        this.props.onUpdateComplete();
    }

    render() {
        return (
            appHelper.isDefined(this.state.score_kpi.kpi_id)
                ?
                <div className="kpi-dashboard" ref={this.objectRef}>
                    <ul className="inline-list text-center">
                        <li className={`inline-item kpi-item`}>
                            <RotationMeter bite_id={this.state.bite.bite_id}
                                           kpiDefaults={this.state.score_kpi}
                                           index={0}
                                           showImmediateImpact={this.props.showImmediateImpact}
                                           meterParams={kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS}
                                           displayState={this.props.displayState}
                                           responseReview={this.props.responseReview}
                                           screen_id={this.props.screen_id}
                                           asset_id={this.props.asset_id}
                                           option_id={typeof this.props.option !== "undefined" ? this.props.option.option_id : 0}
                                           onRotationComplete={this.onUpdateComplete}/>
                        </li>
                    </ul>
                </div>
                : null
        );
    }
}

ScoreKpi.propTypes = {
    displayState: PropTypes.string.isRequired,
    bite_id: PropTypes.number.isRequired,
    bite: PropTypes.object,
    responseReview: PropTypes.bool,
    screen_id: PropTypes.number,
    asset_id: PropTypes.number,
    option: PropTypes.object,
    showImmediateImpact: PropTypes.bool,
    userKpisResults: PropTypes.array,
    onComplete: PropTypes.func,
    onUpdateComplete: PropTypes.func,
    lang: PropTypes.string.isRequired,
};

ScoreKpi.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let userBite = appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.bite_id);
    let bite = appHelper.getBite(ownProps.bite_id);
    let userKpisResults = userBite.kpis;
    let lang = state.userData.lang;
    return {
        lang:lang,
        userKpisResults: userKpisResults,
        bite: bite
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScoreKpi);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/ScoreKpi.js
 **/